import { IObservable, Subject } from '~/rage/utils';
import { HudTaskType, IHudTaskProgress } from '~/shared';
import {
	IDailyTask,
	IDailyTasksProgress,
	IDailyTasksService,
} from './dailyTasksServiceTypes';

export class DailyTasksServiceStub implements IDailyTasksService {
	private mainTasks = new Subject<IDailyTask[]>([]);
	private hudTask = new Subject<IHudTaskProgress | null>({
		type: HudTaskType.DAILY,
		text: 'Набери 150 000 очков дрифта за одно комбо в горах Лос-Сантоса!',
		currentCount: 50000,
		targetCount: 150000,
	});

	private tasksExpireAt = new Subject<number>(Date.now() + 1000 * 60 * 60 * 4);

	private progress = new Subject<IDailyTasksProgress>({
		completed: 1,
		limit: 7,
		maxGivenTasks: 10,
	});

	public getTasks(): IObservable<IDailyTask[]> {
		return this.mainTasks;
	}

	public getTasksExpireAt(): IObservable<number> {
		return this.tasksExpireAt;
	}

	public getDailyTasksProgress(): IObservable<IDailyTasksProgress> {
		return this.progress;
	}

	public getHudTask(): IObservable<IHudTaskProgress | null> {
		return this.hudTask;
	}

	public setIsPinned(_taskId: string, _isPinned: boolean): void {
		// Stub implementation
	}

	public getPinnedTaskId(): string | null {
		return null;
	}
}
